import React from "react";
import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout";

const SECTIONS = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
] as const;

const Privacy = () => {
  const { t } = useTranslation(["legal", "common"]);

  return (
    <Layout title={t("legal:privacy_title")}>
      <div className="max-w-3xl mx-auto py-4 md:py-8">
        <div className="text-center mb-10 md:mb-12">
          <p className="text-caption text-neon-green mb-3">港微創 · Legal</p>
          <h1
            className="text-h1 md:text-display text-gradient-brand mb-4"
            style={{ lineHeight: "125%" }}
          >
            {t("legal:privacy_title")}
          </h1>
          <p
            className="text-body-lg text-gray-400 max-w-2xl mx-auto mb-4"
            style={{ lineHeight: "160%" }}
          >
            {t("legal:privacy_subtitle")}
          </p>
          <p className="text-body-sm text-gray-500">
            {t("common:last_updated")}：{t("legal:last_updated_date")}
          </p>
        </div>

        <div className="space-y-4">
          {SECTIONS.map((key) => (
            <section
              key={key}
              className="rounded-2xl border border-white/10 bg-space-light/50 p-5 md:p-6"
            >
              <h2 className="text-h4 text-white mb-3">
                {t(`legal:privacy_${key}_title`)}
              </h2>
              <div
                className="text-body text-gray-400 leading-relaxed [&_strong]:text-neon-green [&_strong]:font-semibold"
                style={{ lineHeight: "160%" }}
                dangerouslySetInnerHTML={{
                  __html: t(`legal:privacy_${key}_body`),
                }}
              />
            </section>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default Privacy;
